import { createContext, useContext, useState, ReactNode } from "react";

interface ExpandableContextValue {
  expandable: boolean;
  setExpandable: (value: boolean) => void;
}

export const ExpandableContext = createContext<ExpandableContextValue | null>(
  null
);

export function useExpandable() {
  const context = useContext(ExpandableContext);
  if (!context) {
    throw new Error("useExpandable must be used within a ExpandableProvider");
  }
  return context;
}

interface ExpandableProviderProps {
  children: ReactNode;
  defaultExpandable?: boolean;
}

export function ExpandableProvider({
  children,
  defaultExpandable = true,
}: ExpandableProviderProps) {
  const [expandable, setExpandable] = useState(defaultExpandable);

  const value: ExpandableContextValue = {
    expandable,
    setExpandable,
  };

  return (
    <ExpandableContext.Provider value={value}>
      {children}
    </ExpandableContext.Provider>
  );
}
